import React from "react";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f6f6ff] text-[#272e42] gap-4">
      <h1 className="text-7xl font-bold tracking-tight text-[#6d28d9]">Kron</h1>
      <p className="text-lg font-light tracking-[0.3em] uppercase text-[#272e42]/50">
        Coming Soon
      </p>
    </div>
  );
};

export default Home;
